/**
 * @class
 * @function BoomDynamicTabs
 */
if (!customElements.get('boom-dynamic-tabs')) {
  class BoomDynamicTabs extends HTMLElement {
    constructor() {
      super();
      this.isManualScrolling = false; 
      this.scrollTimer = null;
    }
    connectedCallback() {
      this.initTabs();
    }
    initTabs() {
      const sectionId = this.getAttribute('data-section-id');
      const enableSticky = this.getAttribute('data-enable-sticky') === 'true';
      const autoCalculateHeader = this.getAttribute('data-auto-calculate-header') === 'true';
      const dynamicToggleAttr = this.getAttribute('data-dynamic-toggle');
      const tabBgColor = this.getAttribute('data-tab-bg-color');
      const enableDynamicToggle = dynamicToggleAttr !== null 
        ? dynamicToggleAttr === 'true' 
        : false;

      const navBar = this.querySelector(`#TabsNav-${sectionId}`);
      const stickyWrapper = this.querySelector(`#TabsStickyContainer-${sectionId}`);
      const placeholder = this.querySelector(`#TabsPlaceholder-${sectionId}`);
      let tabButtons = Array.from(this.querySelectorAll('.boom-tab-btn'));
      const contentWrappers = this.querySelectorAll('.boom-tab-content-wrapper');
      if (!navBar || !stickyWrapper || !placeholder || tabButtons.length === 0) return;

      if (enableDynamicToggle) {
        tabButtons.forEach((btn) => {
          const actionType = btn.getAttribute('data-target-type');
          const btnToggleOverride = btn.getAttribute('data-dynamic-toggle');
          if (btnToggleOverride === 'false') return;

          if (actionType === 'anchor' || actionType === 'toggle_visibility') {
            const targetId = btn.getAttribute('data-target-id');
            const targetEl = targetId ? document.getElementById(targetId) : null;

            if (!targetEl) {
              btn.style.display = 'none';
              btn.classList.add('boom-tab-hidden');
            }
          }
        });

        tabButtons = tabButtons.filter(btn => btn.style.display !== 'none');
        if (tabButtons.length === 0) return; 
      }

      const toggleElements = [];
      tabButtons.forEach((btn) => {
        if (btn.getAttribute('data-target-type') === 'toggle_visibility') {
          const targetId = btn.getAttribute('data-target-id');
          if (targetId) {
            const el = document.getElementById(targetId);
            if (el) {
              el.style.display = 'none';
              toggleElements.push(el);
            }
          }
        }
      });

      const hideAllToggleElements = () => {
        toggleElements.forEach((el) => { el.style.display = 'none'; });
      };

      const showToggleElement = (targetId) => {
        hideAllToggleElements();
        if (targetId) {
          const el = document.getElementById(targetId);
          if (el) el.style.display = '';
        }
      };

      const getHeaderHeight = () => {
        if (autoCalculateHeader) {
          const headerEl = document.querySelector("header");
          return headerEl ? headerEl.getBoundingClientRect().height : 0;
        }
        return 0;
      };

      const getNavOffset = () => {
        return navBar.offsetHeight + getHeaderHeight() + 20; 
      };
      let initialTop = stickyWrapper.offsetTop;

      const resetSticky = () => {
        if (navBar.style.position === "fixed") {
          navBar.style.position = "relative";
          navBar.style.top = "auto";
          navBar.style.boxShadow = "none";
          navBar.style.zIndex = "999";
          placeholder.style.height = "0px";
          placeholder.classList.add("hidden");
        }
      };

      const handleStickyScroll = () => {
        const currentHeaderOffset = getHeaderHeight();
        if (window.scrollY >= (initialTop - currentHeaderOffset)) {
          if (navBar.style.position !== "fixed") {
            placeholder.style.height = navBar.offsetHeight + "px";
            placeholder.classList.remove("hidden");
            navBar.style.position = "fixed";
            navBar.style.left = "0px";
            navBar.style.width = "100%";
            navBar.style.backgroundColor = tabBgColor;
            navBar.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";
            navBar.style.zIndex = "99"; 
          }
          navBar.style.top = currentHeaderOffset + "px";
        } else {
          resetSticky();
        }
      };

      const anchorButtons = tabButtons.filter(
        btn => btn.getAttribute('data-target-type') === 'anchor' && btn.getAttribute('data-target-id')
      );

      const handleAnchorSpy = () => {
        if (this.isManualScrolling || anchorButtons.length === 0) return;

        const offset = getNavOffset();
        const scrollPosition = window.scrollY + offset;

        let currentActiveBtn = null;

        for (let i = 0; i < anchorButtons.length; i++) {
          const btn = anchorButtons[i];
          const targetId = btn.getAttribute('data-target-id');
          const targetEl = document.getElementById(targetId);

          if (targetEl) {
            const top = targetEl.getBoundingClientRect().top + window.scrollY;
            const height = targetEl.offsetHeight;

            if (scrollPosition >= top && scrollPosition < top + height) {
              currentActiveBtn = btn;
              break;
            }
          }
        }

        if (!currentActiveBtn && (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 50) {
          currentActiveBtn = anchorButtons[anchorButtons.length - 1];
        }

        if (currentActiveBtn && !currentActiveBtn.classList.contains('is-active')) {
         
          switchTab(currentActiveBtn, false);
        }
      };

      const onScroll = () => {
        if (enableSticky) handleStickyScroll();
        handleAnchorSpy();
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", () => {
        const isFixed = (navBar.style.position === "fixed");
        if (isFixed) resetSticky();
        initialTop = stickyWrapper.offsetTop;
        if (isFixed) handleStickyScroll();
      });

      if (enableSticky) handleStickyScroll();

     
      const switchTab = (activeBtn, shouldScrollIntoView = true) => {
        const activeIndex = activeBtn.getAttribute("data-tab-index");
        tabButtons.forEach(btn => btn.classList.remove("is-active"));
        activeBtn.classList.add("is-active");


        if (shouldScrollIntoView) {
          activeBtn.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest',   
            inline: 'center'   
          });
        }

        contentWrappers.forEach((wrapper) => {
          if (wrapper.getAttribute("data-content-index") === activeIndex) {
            wrapper.classList.remove("hidden");
            setTimeout(() => wrapper.classList.add("opacity-100"), 50);
          } else {
            wrapper.classList.add("hidden");
            wrapper.classList.remove("opacity-100");
          }
        });
      };

    
      let initialActiveSet = false;
      tabButtons.forEach((btn) => {
        const type = btn.getAttribute("data-target-type");
        if ((type === 'block_content' || type === 'toggle_visibility') && !initialActiveSet) {
          switchTab(btn, false);
          if (type === 'toggle_visibility') {
            showToggleElement(btn.getAttribute('data-target-id'));
          }
          initialActiveSet = true;
        }
      });

      if (!initialActiveSet && tabButtons.length > 0) {
        switchTab(tabButtons[0], false);
      }

      tabButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          const actionType = button.getAttribute("data-target-type");

          if (actionType === 'anchor') {
            hideAllToggleElements();
            const targetId = button.getAttribute("data-target-id");
            if (targetId) {
              const targetElement = document.getElementById(targetId);
              if (targetElement) {
                switchTab(button, true);

                this.isManualScrolling = true;
                clearTimeout(this.scrollTimer);

                const currentHeaderOffset = getHeaderHeight();
                const offset = navBar.offsetHeight + currentHeaderOffset + 15;

                window.scrollTo({
                  top: targetElement.getBoundingClientRect().top + window.scrollY - offset,
                  behavior: "smooth"
                });

                this.scrollTimer = setTimeout(() => {
                  this.isManualScrolling = false;
                }, 800);
              }
            }
          } else if (actionType === 'block_content') {
            hideAllToggleElements();
            switchTab(button, true);
          } else if (actionType === 'toggle_visibility') {
            showToggleElement(button.getAttribute('data-target-id'));
            switchTab(button, true);
          } else if (actionType === 'open_page') {
            const targetUrl = button.getAttribute("data-target-url");
            if (targetUrl) {
              window.location.href = targetUrl;
            }
          }
        });
      });
    }
  }
  customElements.define('boom-dynamic-tabs', BoomDynamicTabs);
}